<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">
          <a-form-item>
              <a-input
                      v-model:value="searchForm.billNo"
                      placeholder="结算单号"
                      allowClear
              />
          </a-form-item>

        <a-form-item>
          <df-selectChannelShop
            :model="searchForm"
            @setValue="searchAction"
            style="width: 220px"
          ></df-selectChannelShop>
        </a-form-item>

        <a-form-item>
          <a-range-picker
            v-model:value="searchForm.orderdate"
            :placeholder="['账单开始', '账单结束']"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <!-- <template v-slot:checkDate="{ text, record }">
          <div>{{ record.checkBegin + " 至 " + record.checkEnd }}</div>
        </template> -->
        <!-- my self -->
        <a-form-item>
          <a-select
            style="width: 200px"
            v-model:value="formSelect"
            @change="handleChange"
            :labelInValue="true"
          >
            <a-select-option value="0">全部账单</a-select-option>
            <a-select-option value="10">日结算单</a-select-option>
            <a-select-option value="20">账期结算单</a-select-option>
          </a-select>
        </a-form-item>


        <a-form-item>
          <a-select
              style="width: 200px"
              v-model:value="panes"
              @change="handleOrderTypeChange"
              :labelInValue="true"
          >
            <a-select-option value="0">账单类型</a-select-option>
            <a-select-option value="10">出票账单</a-select-option>
            <a-select-option value="20">改签账单</a-select-option>
            <a-select-option value="30">退票账单</a-select-option>
            <a-select-option value="40">退款账单</a-select-option>
          </a-select>
        </a-form-item>



        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="createBill">创建渠道对账单</a-button>
        </a-form-item>

<!--        <a-form-item>
          <a-button @click="createDayBill">创建日结算对账单</a-button>
        </a-form-item>-->

        <a-form-item>
          <a-button @click="batchDownloadDetail">下载详情</a-button>
        </a-form-item>

      </a-form>
    </a-card>
    <!-- 创建对账单 -->
    <a-modal v-model:visible="createVisible" title="创建渠道对账单" :footer="null">
      <a-spin :spinning="createSpinning">
        <a-form layout="inline">
          <a-form-item label="选择渠道">
            <df-selectChannelShop
              :model="createForm"
              style="width: 220px"
            ></df-selectChannelShop>
          </a-form-item>
          <a-form-item label="对账时段：">
            <a-range-picker
              v-model:value="createForm.orderdate"
              :placeholder="['账单开始', '账单结束']"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
            />
          </a-form-item>
          <div style="margin-top: 20px">
            <a-form-item>
              <a-button type="primary" @click="createChannelBill">
                确定
              </a-button>
            </a-form-item>
            <a-form-item>
              <a-button @click="createCancel">取消</a-button>
            </a-form-item>
          </div>
        </a-form>
      </a-spin>
    </a-modal>

    <a-table
      :columns="columns"
      bordered
      :data-source="list"
      :pagination="false"
      :scroll="{ x: 1300 }"
      :row-key="(r) => r.id"
      :loading="loading"
      class="log_content"
      :row-selection="rowSelection"
    >
      <template v-slot:billNo="{ text, record }">
        <div @click="toDetail(record)">{{ record.billNo }}</div>
      </template>

      <template v-slot:checkStateValue="{ text, record }">
        <div :class="{ redClass: record.checkState == 90 }">
          {{ record.checkStateValue }}
        </div>
      </template>

      <template v-slot:checkDate="{ text, record }">
        <div>{{ record.checkBegin + " 至 " + record.checkEnd }}</div>
      </template>

      <template v-slot:operation="{ text, record }">
        <a-button
          type="primary"
          @click="toDetail(record)"
          size="small"
          style="margin-right: 10px"
        >
          查看明细
        </a-button>
        <a-button
          type="danger"
          @click="handleDelete(record)"
          size="small"
          style="margin-right: 10px"
        >
          删除
        </a-button>
        <a-button type="primary" @click="handleDownload(record)" size="small">
          下载
        </a-button>
      </template>
    </a-table>

    <df-pagination :model="pageObj"></df-pagination>
  </div>
</template>

<script>
import { reactive, ref, provide, createVNode } from "vue";
import financialApi from "@axios/financial";
import { useRouter } from "vue-router";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { exportOut } from "@axios/exportOut";
export default {
  name: "channelFinancial",
  components: {
    ExclamationCircleOutlined,
  },
  setup() {

    let activeKey = ref("0");
    let panes = ref({
      key: "0",
    });
    let billType = ref("0");


    const router = useRouter();

    let searchForm = reactive({
      orderdate: [],
      distributorId: "",
      billNo: "",
    });

    let searchParams = reactive({
      distributorId: "",
      tktsStartTime: "",
      tktsEndTime: "",
    });
    const searchAction = () => {
      searchParams.distributorId = searchForm.distributorId;
      if (searchForm.orderdate) {
        searchParams.tktsStartTime = searchForm.orderdate[0];
        searchParams.tktsEndTime = searchForm.orderdate[1];
      } else {
        searchParams.tktsStartTime = "";
        searchParams.tktsEndTime = "";
      }
      searchParams.billNo = searchForm.billNo;

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    const reset = () => {
      searchForm.distributorId = "";
      searchForm.orderdate = [];
      searchForm.billNo = "";
      searchAction();
    };

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    let loading = ref(false);
    let list = ref([]);

    const getList = () => {
      let params = {
        billOrderType: billType.value == "0"?null : billType.value,
        billType: activeKey.value == "0" ? null : activeKey.value,
        billNo: searchParams.billNo ? searchParams.billNo : null,
        distributorId: searchParams.distributorId
          ? searchParams.distributorId
          : null,
        checkBegin: searchParams.tktsStartTime
          ? searchParams.tktsStartTime
          : null,
        checkEnd: searchParams.tktsEndTime ? searchParams.tktsEndTime : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows
      };
      loading.value = true;

      financialApi.getElectronicFinancialList(params).then((res) => {
        console.log(res);
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
    };
    getList();

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    // 详情
    const toDetail = (row) => {
      router.push({
        name: "electronicChannelDetail",
        query: {
          id: row.id,
          billNo: row.billNo,
          checkState: row.checkState,
          billOrderType:row.billOrderType
        },
      });
    };
    // 删除渠道账单
    const handleDelete = (item) => {
      console.log(item);
      Modal.confirm({
        title: "是否确认删除？",
        icon: createVNode(ExclamationCircleOutlined),
        content: "",
        onOk() {
          financialApi.delElectronicDistributor(item.id).then((res) => {
            console.log(res);
            message.success("删除成功");
            getList();
          });
        },
        onCancel() {},
      });
    };

    const getBillOrderType = (val) => {
      if (val === 10){
        return '出票';
      }else if(val === 20){
        return '改签'
      }else if(val === 30){
        return '退票'
      }else if(val === 40){
        return '退款'
      }else if(val === 50){
        return '出退改'
      }
    }

    const handleDownload = (item) => {
      let params = {
        billNo: item.billNo,
        billOrderType:item.billOrderType
      };
      const name = getBillOrderType(params.billOrderType)+'单线下票渠道结算单明细';

      let fileName = name + item.billNo;
      exportOut(
        params, // 导出请求参数
        "/app-finance/electronic/distributor/bill/download", // 接口地址
        fileName // 导出文件名字
      );
    };

    // 创建渠道对账单
    let createVisible = ref(false);
    const createBill = () => {
      createVisible.value = true;
    };
    let createForm = reactive({
      distributorId: "",
      orderdate: [],
    });

    let createParams = reactive({
      distributorId: "",
      tktsStartTime: "",
      tktsEndTime: "",
    });
    const createCancel = () => {
      createVisible.value = false;
      createSpinning.value = false;
    };
    let formSelect = ref({
      key: "0",
    });

    //创建渠道账单
    let createChannelBill = () => {
      if (
        createForm.distributorId !== "" &&
        createForm.distributorId !== undefined &&
        createForm.orderdate.length !== 0
      ) {
        createSpinning.value = true;
        createParams.distributorId = createForm.distributorId;
        if (createForm.orderdate) {
          createParams.tktsStartTime = createForm.orderdate[0];
          createParams.tktsEndTime = createForm.orderdate[1];
        } else {
          createParams.tktsStartTime = "";
          createParams.tktsEndTime = "";
        }
        let params = {
          distributorId: createParams.distributorId
            ? createParams.distributorId
            : null,
          checkBegin: createParams.tktsStartTime
            ? createParams.tktsStartTime
            : null,
          checkEnd: createParams.tktsEndTime ? createParams.tktsEndTime : null,
        };
        //发送创建请求
        financialApi.createElectronicChannelBill(params).then((res) => {
          message.success("创建成功");
          createSpinning.value = false;
          createVisible.value = false;
          getList();
        });
      } else {
        message.info("您有必要信心未填写");
      }
    };


    //创建渠道账单
    let createDayBill = () => {
        let params = {
        };
        //发送创建请求
        financialApi.createDayChannelBill(params).then((res) => {
          message.success("创建成功");
          createSpinning.value = false;
          createVisible.value = false;
          getList();
        });
    };


    const getChannelList = () => {
      loading.value = true;
    };
    //创建对账单完毕
    let createSpinning = ref(false);
    //切换系统对账单和手动对账单
    let handleChange = (obj) => {
      activeKey.value = obj.key;
      reset();
    };

    let handleOrderTypeChange = (obj) => {
      billType.value = obj.key
      searchAction();
      //reset();
    };

    let batchSelectData = ref([]);

    //根据选择批量下载账单详情
    const batchDownloadDetail = () => {

      if (batchSelectData.value.length <= 0){
        message.warn("请先选择要下载的账单")
        return
      }
      batchSelectData.value.forEach(item=>{
        console.log("download item{}",item)
        let params = {
          billNo: item.billNo,
          billOrderType:item.billOrderType
        };
        const name = getBillOrderType(params.billOrderType)+'单线下票渠道结算单明细';
        let fileName = name + item.billNo;
        exportOut(
            params, // 导出请求参数
            "/app-finance/electronic/distributor/bill/download", // 接口地址
            fileName // 导出文件名字
        );
      })
    };
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        //onsole.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        batchSelectData.value = selectedRows
        //console.log("batchDownloadData{}",batchDownloadData)
      },
      onSelect: (record, selected, selectedRows) => {
        console.log(record, selected, selectedRows);
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        console.log(selected, selectedRows, changeRows);
      },
    };
    return {
      createDayBill,
      batchDownloadDetail,
      batchSelectData,
      rowSelection,
      panes,
      billType,
      activeKey,
      handleOrderTypeChange,
      handleChange,
      createSpinning,
      createChannelBill,
      getChannelList,
      formSelect,
      createVisible,
      createBill,
      createParams,
      createForm,
      createCancel,
      //上面是二次开发变量
      list,
      loading,
      pageObj,
      reset,
      searchForm,
      searchAction,
      columns: [
        {
          title: "结算单编号",
          dataIndex: "billNo",
          width: 200,
          align: "center",
          slots: { customRender: "billNo" },
          className: `${"underlineStyle"}`,
        },
        {
          title: "渠道",
          dataIndex: "distributorName",
          width: 120,
          align: "center",
        },
        {
          title: "账单类型",
          dataIndex: "billOrderTypeStr",
          width: 100,
          align: "center",
          slots: { customRender: "billOrderTypeStr" },
        },
        {
          title: "订单数",
          dataIndex: "orderCount",
          width: 100,
          align: "center",
          slots: { customRender: "orderCount" },
        },
        {
          title: "票数",
          dataIndex: "ticketCount",
          width: 100,
          align: "center",
          slots: { customRender: "ticketCount" }
        },
        {
          title: "销售金额",
          dataIndex: "saleAmount",
          width: 100,
          align: "center",
          slots: { customRender: "saleAmount" },
        },
        {
          title: "结算金额",
          dataIndex: "orderAmount",
          width: 100,
          align: "center",
          slots: { customRender: "orderAmount" },
        },
        {
          title: "退款金额",
          dataIndex: "retrunAmount",
          width: 100,
          align: "center",
          slots: { customRender: "retrunAmount" },
        },
        {
          title: "生成时间",
          dataIndex: "createTime",
          width: 150,
          align: "center",
        },
        {
          title: "对账时段",
          dataIndex: "checkDate",
          width: 340,
          align: "center",
          slots: { customRender: "checkDate" },
        },
        {
          title: "操作",
          dataIndex: "",
          width: 250,
          align: "center",
          slots: { customRender: "operation" },
          fixed: "right"
        }
      ],
      toDetail,
      handleDelete,
      handleDownload,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 70px;
}
.log_content {
  .redClass {
    color: red;
  }
}
</style>
